import React from "react";
import { Link } from "react-router-dom";

import {
  Button,
} from "AWS-UI-Components-React";

import { truncate } from "../data/constdata.jsx";

export const testCaseTableColumnDefinitions = [
  {
    id: "testSuite",
    header: "Test Suite",
    cell: item => item.testSuite
  },
  {
    id: "testName",
    header: "Test Name",
    cell: item => item.testName
  },
  {
    id: "timestamp",
    header: "Version ID",
    cell: item => item.timestamp
  },
  {
    id: "testBody",
    header: "Test Body",
    cell: item => <code>{JSON.stringify(JSON.parse(item.testBody),null,'\t')}</code>
  }
  // ,
  // {
  //   id: "details",
  //   header: "Details",
  //   // eslint-disable-next-line react/display-name
  //   cell: item => <div>
  //     <Link
  //       to={{
  //         pathname: `/test-cases/${item.id}`,
  //         state: { testCase: item }
  //       }}
  //     >
  //       <Button wrapText={false}>
  //         View Test Case
  //       </Button>
  //     </Link>
  //   </div>
  // }
];


// WEBPACK FOOTER //
// ./src/data/testCaseTableColumnDefinitions.jsx